import axios from "../../axios";
import {
  SECTION_ADD_SUCCESS,
  SECTION_ADD_REQUEST,
  SECTION_ADD_FAIL,
  //
  SECTION_LIST_SUCCESS,
  SECTION_LIST_REQUEST,
  SECTION_LIST_FAIL,
  //
  SECTION_STORE_LIST_SUCCESS,
  SECTION_STORE_LIST_REQUEST,
  SECTION_STORE_LIST_FAIL,
  //
  SECTION_DETAIL_SUCCESS,
  SECTION_DETAIL_REQUEST,
  SECTION_DETAIL_FAIL,
  //
  SECTION_DELETE_SUCCESS,
  SECTION_DELETE_REQUEST,
  SECTION_DELETE_FAIL,
  //
  SECTION_UPDATE_SUCCESS,
  SECTION_UPDATE_REQUEST,
  SECTION_UPDATE_FAIL,
  //

  //
} from "../constants/sectionConstants";

// get all sections
export const getListSectionsByStore =
  (page, store = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: SECTION_STORE_LIST_REQUEST,
      });
      var {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.access}`,
        },
      };
      const { data } = await axios.get(
        `/sections/store/${store}/?page=${page}`,
        config
      );

      dispatch({
        type: SECTION_STORE_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      var err =
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail;
      if (err) {
        if (
          err === "Given token not valid for any token type" ||
          err === "User not found"
        ) {
          localStorage.removeItem("userInfoExpressHalalAdmin");
          document.location.href = "/";
        }
      }
      dispatch({
        type: SECTION_STORE_LIST_FAIL,
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.detail,
      });
    }
  };

// delete section
export const deleteSection = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SECTION_DELETE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.delete(`/sections/delete/${id}/`, config);

    dispatch({
      type: SECTION_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: SECTION_DELETE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "Votre profile n'a pas été modifié, réessayez",
    });
  }
};

// create category
export const updateCategory = (id, category) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SECTION_UPDATE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.put(
      `/categories/update/${id}/`,
      category,
      config
    );

    dispatch({
      type: SECTION_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: SECTION_UPDATE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get category detail
export const getCategoryDetail = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SECTION_DETAIL_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/categories/detail/${id}/`, config);

    dispatch({
      type: SECTION_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (err === "Given token not valid for any token type") {
        localStorage.removeItem("userInfoUnimedCare");
        document.location.href = "/";
      }
    }
    dispatch({
      type: SECTION_DETAIL_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};

// create section
export const addNewSection = (section) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SECTION_ADD_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.post(`/sections/create/`, section, config);

    dispatch({
      type: SECTION_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: SECTION_ADD_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get all sections
export const getListSections = (page) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SECTION_LIST_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/sections/?page=${page}`, config);

    dispatch({
      type: SECTION_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: SECTION_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};
